import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
function formatBytes(n) {
    if (!n && n !== 0)
        return "—";
    const u = ["B", "KB", "MB", "GB", "TB"];
    let v = n;
    let i = 0;
    while (v >= 1024 && i < u.length - 1) {
        v /= 1024;
        i += 1;
    }
    return `${v.toFixed(1)} ${u[i]}`;
}
export function ExportPanel({ backupId }) {
    const qc = useQueryClient();
    const { data } = useQuery({
        queryKey: ["export-status", backupId],
        queryFn: async () => (await api.get(`/backups/${backupId}/export/status`)).data,
        refetchInterval: 4000,
    });
    const trigger = useMutation({
        mutationFn: () => api.post(`/backups/${backupId}/export`),
        onSuccess: () => qc.invalidateQueries({ queryKey: ["export-status", backupId] }),
    });
    const job = data?.job;
    const inflight = job && (job.state === "queued" || job.state === "running");
    return (_jsxs("div", { className: "rounded border border-slate-200 bg-white p-4", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx("h3", { className: "text-sm font-medium text-slate-700", children: "Full export (ZIP)" }), data?.exists ? (_jsxs("a", { href: `/api/v1/backups/${backupId}/export/download`, className: "rounded border border-emerald-600 bg-emerald-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-emerald-700", children: ["Download \u00B7 ", formatBytes(data.size_bytes)] })) : (_jsx("button", { onClick: () => trigger.mutate(), disabled: trigger.isPending || inflight === true, className: "rounded border border-brand-600 bg-brand-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-brand-700 disabled:opacity-60", children: inflight ? `${job?.current_phase ?? "running"}…` : "Generate ZIP" }))] }), job && job.state !== "succeeded" && (_jsxs("div", { className: "mt-2 text-xs text-slate-500", children: [job.state, " \u00B7 ", job.progress_pct, "% \u00B7 ", job.current_phase ?? "—", job.error_text && _jsx("span", { className: "ml-2 text-red-600", children: job.error_text })] }))] }));
}
